const content = {
  content_about_us_developer: 'SignalStickerMaker.com（網頁）, Sigicker（iOS）, SignalSticker Maker（Android）皆由以下開發者開發：',
  content_about_us_ads: '呢個App完全由開發者自資，包括Sever Hosting，network，App Development等成本。廣告係我地嘗試收返幾毫子嘅唯一途徑。我地已經將廣告帶來嘅影響降到最低了。',
  faq_question_1: '我Upload嘅相會唔會Save落你地嘅Server？',
  faq_answer_1: '唔會！Sticker Pack整好之後，所有相都會Delete走',
  faq_question_2: '我可唔可以修改整好咗嘅Sticker Pack？',
  faq_answer_2: '由於Signal嘅限制，你只可以重新整過成個Sticker Pack。',
  faq_question_3: '可唔可以指定Sticker Pack嘅封面同Sticker嘅Emoji?',
  faq_answer_3: '我地仲整梗！好快有得用！',
};

const text = {
  text_about_us: '關於我們',
  text_developers: '開發者',
  text_advertisement: '廣告',
  text_image_selected: '已選圖片',
  text_image_selected_error: '請選最少1張圖片，最多30張圖片',
  text_maximum: '最多',
  text_supported_format: '支援格式',
  text_field_title: '標題',
  text_field_author: '作者',
  text_make_your_own_sticker: '自己整個獨一無二嘅Signal貼圖!',
  text_select_images: '選擇圖片',
  text_create_sticker: '製作貼圖',
  text_terms_and_conditions: '條款和細則',
  text_terms_and_conditions_2: '您在此聲明您已閱讀並同意',
  text_optional: '選填',
  text_download_now: '現加就Download啦！',
  text_compability: '兼容性',
  text_compability_android: 'Android 4.4+ 嘅Android手機',
  text_developed_by: '用以下技術整出嚟：',
  text_ssm_on_android: 'SignalStickerMaker可以喺Android用啦！',
  text_android_trade_mark: '"Android", "Android Studio", "Google PlayStore" 及其商標皆為 Google LLC 所有。',
  text_ssm_on_ios: 'SignalStickerMaker可以喺iOS用啦！',
  text_compability_ios_1: '配備 iOS 13+ 嘅 iPhone, iPad, iPod Touch',
  text_compability_ios_2: '配備 macOS 11.0+ 同 Apple M1晶片嘅Mac',
  text_ssm_trade_mark: 'Apple®, Mac®, Mac OS®, iPhone®, iPad®, iPod touch®, App Store®, Swift®, Xcode®，及其商標皆為 Apple Inc.在美國和其他國家的註冊商標。',
  text_faq: '常見問題',
  text_stats: '統計',
  text_statistics: '統計',
  text_total_sticker_packs: '在呢到整過嘅Sticker Pack總數',
  text_terms_privacy_condition: '條款、隱私和細則',
  text_copy_right: '版權所有',
  text_give_app_a_try_question: '試下我地嘅App版本？',
  text_better_experience: '更好嘅體驗',
  text_store_your_sticker: '儲低Sticker',
  text_more_convenient: '更加方便',
  text_no_thanks: '不了！',
  text_creating_sticker: '幫緊你幫緊你...(整緊Sticker)',
  text_close: '關閉',
  text_cancel: '取消',
  text_copy_to_clipboard: '複製到剪貼簿',
  text_copied: '已複製',
  text_add_sticker_now: '加Sticker啦',
  text_try_again: '再試一次',
  text_report_to_us: '向我地報告',
  text_reported: '已報告',
  text_image_converting: '轉換緊圖片...',
  text_sticker_created_successfully: '成功整出Sticker！',
  text_service_busy: 'Signal上載服務忙緊，等陣再試。',
  text_upload_failed_try_again: '上載失敗，等陣再試。',
  text_image_uploading: '上載緊圖片...',
  text_step_converting_image: '轉換緊圖片',
  text_step_uploading_image: '上載緊圖片',
  text_step_result: '結果',
  text_educational_title: '幾分鐘內建立專業嘅Signal貼圖包',
  text_educational_description: '用我哋免費、易用嘅工具將你嘅圖片轉換做自訂Signal貼圖包。無論你係為朋友製作個人貼圖、商業品牌材料定係藝術表達，我哋嘅平台令流程變得簡單同安全。唔使技術技能！',
  text_quick_tips_title: '💡 製作更好貼圖嘅快速貼士',
  text_tip_1: '用高解像度圖片（最少512x512像素）獲得清晰效果',
  text_tip_2: 'PNG格式最啱有透明背景嘅圖片',
  text_tip_3: '保持設計簡',
  text_tip_4: '每次建立10-30個貼圖獲得最佳效果',
  text_about_signal_title: '關於Signal',
  text_about_signal_description: 'Signal係一個注重私隱嘅通訊應用程式，支援自訂貼圖包。創建同分享你獨特嘅貼圖，令你嘅對話更加個人化同有趣。',
  text_sticker_guide_card_title: '完整貼圖指南',
  text_sticker_guide_card_description: '學習最佳實踐、設計原則以及創建專業Signal貼圖包嘅逐步說明。',
  text_image_formats_card_title: '圖片格式指南',
  text_image_formats_card_description: '了解PNG、WEBP、JPEG同GIF格式之間嘅差異，為你嘅貼圖選擇最佳選項。',
  text_learn_more: '了解更多',
  // Sticker Guide Section - Cantonese
  sticker_guide_image_quality_title: '貼圖質素建議',
  sticker_guide_image_quality_1: '用高解像度圖片（最少512x512像素）',
  sticker_guide_image_quality_2: '保持圖片清晰，唔好模糊',
  sticker_guide_image_quality_3: '避免過度壓縮或失真',
  sticker_guide_design_principles_title: '設計原則',
  sticker_guide_design_principles_1: '設計簡潔，容易識別',
  sticker_guide_design_principles_2: '用鮮明顏色同清楚輪廓',
  sticker_guide_design_principles_3: '確保貼圖喺深色/淺色背景都清楚',
  sticker_guide_formats_title: '貼圖格式比較',
  sticker_guide_formats_description: 'Signal貼圖支援PNG、WEBP、JPEG同GIF。每種格式有唔同優點：',
  sticker_guide_png_title: 'PNG（透明背景）',
  sticker_guide_png_best_for: '最啱有透明背景嘅貼圖',
  sticker_guide_png_advantages: '無損壓縮，品質高',
  sticker_guide_png_file_size: '檔案較大',
  sticker_guide_webp_title: 'WEBP（高效壓縮）',
  sticker_guide_webp_best_for: '最啱需要細檔案又高品質嘅貼圖',
  sticker_guide_webp_advantages: '支援透明，檔案細',
  sticker_guide_webp_file_size: '檔案最細',
  sticker_guide_jpeg_title: 'JPEG（相片）',
  sticker_guide_jpeg_best_for: '最啱用於相片類貼圖',
  sticker_guide_jpeg_advantages: '檔案細，支援多顏色',
  sticker_guide_jpeg_limitations: '唔支援透明，壓縮後可能失真',
  sticker_guide_gif_title: 'GIF（動畫）',
  sticker_guide_gif_best_for: '最啱簡單動畫貼圖',
  sticker_guide_gif_advantages: '支援動畫',
  sticker_guide_gif_limitations: '顏色少，唔支援透明',
  sticker_guide_how_to_title: '如何創建Signal貼圖',
  sticker_guide_how_to_description: '跟住以下步驟就可以輕鬆整貼圖：',
  sticker_guide_step_1: '揀選你想用嘅圖片',
  sticker_guide_step_2: '確保圖片符合質素要求',
  sticker_guide_step_3: '選擇合適格式（PNG/WEBP/JPEG/GIF）',
  sticker_guide_step_4: '用Signal貼圖製作器上載圖片',
  sticker_guide_step_5: '預覽同調整貼圖',
  sticker_guide_step_6: '完成後下載或分享貼圖包',
  sticker_guide_advanced_tips_title: '進階貼士',
  sticker_guide_advanced_tips_description: '想貼圖更受歡迎？試下以下貼士：',
  sticker_guide_consistency_title: '風格一致',
  sticker_guide_consistency_description: '一個貼圖包最好有統一風格同主題。',
  sticker_guide_emotional_range_title: '表情多樣',
  sticker_guide_emotional_range_description: '設計唔同情感同反應嘅貼圖，令對話更豐富。',
  sticker_guide_test_others_title: '搵朋友試用',
  sticker_guide_test_others_description: '分享貼圖俾朋友試下，收集意見再改進。',
  
  // Sticker Guide Page
  sticker_guide_page_title: '創建Signal貼圖完整指南',
  sticker_guide_page_description: '通過我哋嘅綜合指南學習如何創建專業嘅Signal貼圖包。發現最佳實踐、檔案格式、設計技巧同逐步說明。',
  sticker_guide_what_are_title: '咩係Signal貼圖？',
  sticker_guide_what_are_description: 'Signal貼圖係你可以喺Signal對話中使用嘅自訂表情符號同圖片，用嚟表達情感、反應同想法。同普通表情符號唔同，Signal貼圖可以完全自訂同個人化，令你創造獨特嘅視覺溝通體驗。',
  sticker_guide_why_use_title: '點解使用自訂貼圖？',
  sticker_guide_why_use_description: '自訂貼圖相對於標準表情符號有幾個優勢：',
  sticker_guide_advantage_1: '個人表達：創建反映你個性、幽默或內部笑話嘅貼圖',
  sticker_guide_advantage_2: '品牌識別：企業可以創建品牌貼圖用於客戶參與',
  sticker_guide_advantage_3: '文化相關性：創建同你嘅文化背景或社區共鳴嘅貼圖',
  sticker_guide_advantage_4: '難忘嘅溝通：用獨特嘅視覺元素喺對話中脫穎而出',
  sticker_guide_best_practices_title: '貼圖創建最佳實踐',
  sticker_guide_best_practices_description: '要創建有效同吸引人嘅貼圖，請遵循呢啲指導原則：',
  sticker_guide_ready_title: '準備好創建你自己嘅貼圖未？',
  sticker_guide_ready_description: '而家你了解咗貼圖創建嘅基礎知識，你已經準備好將想法變為現實！使用我哋免費嘅Signal貼圖製作器將你嘅圖片轉換為專業嘅貼圖包，你可以同朋友、家人或整個Signal社區分享。',
  
  // Image Formats Page
  image_formats_page_title: '理解圖片格式：完整指南',
  image_formats_page_description: '喺今日嘅數碼世界中，選擇正確嘅圖片格式可以顯著影響你網站嘅性能、用戶體驗同視覺品質。無論你係喺創建貼圖、建設網站定係分享相片，理解圖片格式之間嘅差異對於做出明智決策至關重要。',
  image_formats_what_are_title: '咩係圖片格式？',
  image_formats_what_are_description: '圖片格式係組織同儲存數碼圖片資料嘅標準化方式。每種格式使用唔同嘅壓縮演算法、顏色表示同功能集嚟平衡檔案大小、品質同功能性。格式嘅選擇取決於你嘅特定需求：網絡性能、列印品質、透明度支援或動畫功能。',
  image_formats_comparison_title: '詳細格式比較',
  image_formats_future_title: '圖片格式嘅未來',
  image_formats_future_description: '圖片格式領域繼續隨住新技術而發展：',
  
  // PNG Section
  image_formats_png_title: 'PNG (便攜式網絡圖形)',
  image_formats_png_description: 'PNG係一種無損壓縮格式，已經成為需要透明度嘅網頁圖形標準。',
  image_formats_png_features_title: '主要特色：',
  image_formats_png_feature_1: '無損壓縮 - 冇品質劣化',
  image_formats_png_feature_2: '完整alpha通道透明度支援',
  image_formats_png_feature_3: '支援高達1670萬種顏色',
  image_formats_png_feature_4: '非常適合具有銳利邊緣同文字嘅圖形',
  image_formats_png_uses_title: '最佳使用情況：',
  image_formats_png_use_1: '網站標誌同圖示',
  image_formats_png_use_2: '螢幕截圖同使用者介面元素',
  image_formats_png_use_3: '需要透明背景嘅圖片',
  image_formats_png_use_4: '帶有文字覆蓋嘅圖形',
  image_formats_png_limitations_title: '限制：',
  image_formats_png_limitations: '與有損格式相比檔案大小較大，唔太適合檔案大小係考量嘅大型攝影圖片。',

  // WEBP Section
  image_formats_webp_title: 'WEBP (網頁圖片格式)',
  image_formats_webp_description: '由Google開發，WEBP係一種現代圖片格式，喺保持高品質嘅同時提供卓越嘅壓縮。',
  image_formats_webp_features_title: '主要特色：',
  image_formats_webp_feature_1: '比PNG細25-35%嘅檔案大小',
  image_formats_webp_feature_2: '支援有損同無損壓縮',
  image_formats_webp_feature_3: 'Alpha通道透明度支援',
  image_formats_webp_feature_4: '動畫支援（優於GIF）',
  image_formats_webp_uses_title: '最佳使用情況：',
  image_formats_webp_use_1: '現代網頁應用程式',
  image_formats_webp_use_2: '行動應用程式資源',
  image_formats_webp_use_3: '電子商務產品圖片',
  image_formats_webp_use_4: '任何檔案大小重要嘅情況',
  image_formats_webp_limitations_title: '限制：',
  image_formats_webp_limitations: '喺舊版瀏覽器中支援有限（雖然呢個問題正在減少）。某啲圖片編輯軟體可能唔完全支援WEBP編輯。',

  // JPEG Section
  image_formats_jpeg_title: 'JPEG (聯合攝影專家組)',
  image_formats_jpeg_description: 'JPEG係攝影圖片最廣泛使用嘅格式，為複雜圖片提供出色嘅壓縮。',
  image_formats_jpeg_features_title: '主要特色：',
  image_formats_jpeg_feature_1: '攝影嘅出色壓縮',
  image_formats_jpeg_feature_2: '適合網頁使用嘅細檔案大小',
  image_formats_jpeg_feature_3: '通用嘅瀏覽器同設備支援',
  image_formats_jpeg_feature_4: '可調整嘅品質設定',
  image_formats_jpeg_uses_title: '最佳使用情況：',
  image_formats_jpeg_use_1: '數位攝影',
  image_formats_jpeg_use_2: '社群媒體圖片分享',
  image_formats_jpeg_use_3: '網站主圖同圖庫',
  image_formats_jpeg_use_4: '電子郵件附件',
  image_formats_jpeg_limitations_title: '限制：',
  image_formats_jpeg_limitations: '有損壓縮可能隨住重複編輯而降低品質。唔支援透明度。對包含銳利邊緣或文字嘅圖形性能差。',

  // GIF Section
  image_formats_gif_title: 'GIF (圖形交換格式)',
  image_formats_gif_description: '儘管係最古老嘅網頁格式之一，GIF仍然受到簡單動畫同圖形嘅歡迎。',
  image_formats_gif_features_title: '主要特色：',
  image_formats_gif_feature_1: '動畫支援',
  image_formats_gif_feature_2: '單色透明度',
  image_formats_gif_feature_3: '簡單圖形嘅無損壓縮',
  image_formats_gif_feature_4: '所有平台嘅通用支援',
  image_formats_gif_uses_title: '最佳使用情況：',
  image_formats_gif_use_1: '簡單動畫同迷因',
  image_formats_gif_use_2: '載入指示器同UI動畫',
  image_formats_gif_use_3: '顏色較少嘅簡單圖形',
  image_formats_gif_use_4: '像素藝術同復古風格圖形',
  image_formats_gif_limitations_title: '限制：',
  image_formats_gif_limitations: '限制為256種顏色，唔適合高品質攝影。複雜動畫嘅檔案大小較大。唔支援alpha透明度。',

  // Decision Matrix Section
  image_formats_decision_matrix_title: '選擇正確格式：決策矩陣',
  image_formats_decision_guide: '快速決策指南：',
  image_formats_transparency_title: '透明度',
  image_formats_transparency_best: '最佳：PNG、WEBP',
  image_formats_transparency_avoid: '避免：JPEG',
  image_formats_photography_title: '攝影',
  image_formats_photography_best: '最佳：JPEG、WEBP',
  image_formats_photography_avoid: '避免：GIF',
  image_formats_animation_title: '動畫',
  image_formats_animation_best: '最佳：WEBP、GIF',
  image_formats_animation_avoid: '避免：JPEG、PNG',
  image_formats_filesize_title: '檔案大小',
  image_formats_filesize_best: '最佳：WEBP、JPEG',
  image_formats_filesize_largest: '最大：PNG',

  // Technical Specifications
  image_formats_tech_specs_title: '技術規格比較',
  image_formats_tech_feature: '特色',
  image_formats_tech_compression: '壓縮類型',
  image_formats_tech_transparency: '透明度',
  image_formats_tech_animation: '動畫',
  image_formats_tech_colors: '最大顏色數',
  image_formats_tech_browser: '瀏覽器支援',
  image_formats_tech_lossless: '無損',
  image_formats_tech_both: '兩者',
  image_formats_tech_lossy: '有損',
  image_formats_tech_alpha: 'Alpha通道',
  image_formats_tech_no: '唔係',
  image_formats_tech_binary: '二進位',
  image_formats_tech_yes: '係',
  image_formats_tech_colors_full: '1670萬',
  image_formats_tech_colors_limited: '256',
  image_formats_tech_universal: '通用',
  image_formats_tech_modern: '現代',

  // Performance Section
  image_formats_performance_title: '對網站性能嘅影響',
  image_formats_performance_description: '圖片格式嘅選擇顯著影響網站性能，直接影響使用者體驗同SEO排名：',
  image_formats_loading_title: '載入速度',
  image_formats_loading_description: '較細嘅檔案大小（WEBP、優化嘅JPEG）導致更快嘅頁面載入時間，呢個對使用者保留同SEO至關重要。頁面載入時間延遲1秒可能會減少7%嘅轉換率。',
  image_formats_mobile_title: '行動體驗',
  image_formats_mobile_description: '喺頻寬有限嘅行動設備上，選擇WEBP等高效格式可以顯著改善使用者體驗。行動使用者期望頁面喺3秒內載入。',
  image_formats_seo_title: 'SEO效益',
  image_formats_seo_description: 'Google將頁面速度視為排名因素。優化嘅圖片有助於更好嘅核心網頁指標分數，可能改善你嘅搜尋引擎排名。',

  // Future Section
  image_formats_future_avif: 'AVIF：提供比WEBP更好壓縮嘅新格式，正在緩慢獲得瀏覽器支援',
  image_formats_future_heif: 'HEIF：Apple針對iOS設備嘅首選格式，壓縮出色但網頁支援有限',
  image_formats_future_svg: 'SVG：完美適用於可縮放圖形同圖示嘅向量格式',

  // Conclusion
  image_formats_conclusion_title: '準備優化你嘅圖片未？',
  image_formats_conclusion_description: '而家你了解咗每種圖片格式嘅優缺點，你可以為你嘅專案做出明智嘅決策。無論你係喺創建Signal貼圖、建設網站定係在線分享內容，選擇正確嘅格式將確保為你嘅特定需求提供品質、性能同相容性嘅最佳平衡。',
};

const language_spec = {
  lang_code: 'hk',
  name: '廣東話',
  flag: '🇭🇰',
};

const menu_items = {
  menu_item_ios: 'iOS',
  menu_item_android: 'Android',
  menu_item_faq: '常見問題',
  menu_item_about_us: '關於我們',
  menu_item_support: '支援',
  menu_item_create_stickers: '創建貼圖',
  menu_item_sticker_guide: '貼圖指南',
  menu_item_image_formats: '圖片格式',
};

const seo = {
  seo_default_title: 'Signal Sticker Maker - 整你自己嘅貼圖',
  seo_default_description: '免費Signal貼圖製作工具 - 幾分鐘就可以為Signal訊息應用程式整自訂貼圖。用我哋嘅簡單易用網上工具整個人化貼圖包。唔需要安裝軟件，手機同電腦都用得。',
  seo_support_title: '支援',
  seo_support_description: '聯繫我們以獲得支援',
  seo_ios_description: 'SignalStickerMaker.com 嘅 iOS APP 可以喺 App Store下載啦！',
  seo_android_description: 'SignalStickerMaker.com 嘅 Android APP 可以喺 Google Play Store下載啦！',
  seo_about_us_description: 'SignalStickerMaker.com 嘅故事',
  seo_faq_title: '常見問題',
  seo_faq_description: '瀏覽常見問題',
  seo_title_support: '支援',
  seo_title_support_description: '聯繫我們獲得支援和協助',
  canvas: '畫布',
  stickerCount: '貼圖數量',
  about_us_mission_title: '我地使命',
  about_us_mission_content: '喺 Signal Sticker Maker，我地相信溝通應該係個人化、有趣同具創意嘅。我地嘅使命係讓貼圖製作民主化，讓任何人都可以輕鬆地用自訂Signal貼圖來表達自己。無論你係同朋友分享內部笑話、為企業建立品牌形象，定係只係想在對話中加入一些個性，我地都提供工具來實現 - 完全免費。',
  about_us_why_built_title: '點解我地要整呢個',
  about_us_why_built_content: 'Signal Sticker Maker嘅想法來自我地對於自訂貼圖選擇有限嘅沮喔。我地想要一個簡單、易於使用嘅工具，唔需要技術專業或昂貴軟件。以下係我地嘅動力：',
  about_us_accessibility: '可及性：無論技術技能如何，任何人都應該能夠製作自訂貼圖',
  about_us_privacy: '私隱：你嘅圖片會安全處理，永遠唔會儲存在我地伺服器上',
  about_us_simplicity: '簡單：製作過程應該只需要幾分鐘，唔係幾個鐘頭',
  about_us_quality: '品質：最終嘅貼圖應該係高品質同兼容Signal嘅',
  about_us_team_description: '我哋嘅團隊結合咗網頁開發、用戶體驗設計同手機應用程式嘅專業知識，創造出既強大又易用嘅工具。我哋熱衷於開源技術，相信要建立尊重用戶私隱同時提供卓越功能嘅產品。',
  about_us_tech_stack_title: '我哋嘅技術堆疊',
  about_us_tech_stack_description: '我哋用現代網頁技術嚟建立Signal Sticker Maker，確保可靠性、速度同安全性：',
  about_us_frontend_title: '前端',
  about_us_frontend_description: '用React.js同TypeScript打造響應式、類型安全嘅用戶介面',
  about_us_backend_title: '後端',
  about_us_backend_description: 'AWS Lambda無伺服器處理同S3安全檔案處理',
  about_us_security_title: '安全',
  about_us_security_description: '端到端加密同自動檔案刪除，確保最大私隱保護',
  about_us_privacy_security_title: '私隱同安全',
  about_us_privacy_security_description: '你嘅私隱係我哋嘅首要考慮。以下係我哋保護你資料嘅方法：',
  about_us_privacy_point_1: '盡可能喺客戶端處理圖片',
  about_us_privacy_point_2: '上載嘅檔案會喺處理後自動刪除',
  about_us_privacy_point_3: '我哋唔會追蹤個人資訊或儲存用戶資料',
  about_us_privacy_point_4: '所有通訊都用業界標準協議加密',
  about_us_community_title: '社區影響',
  about_us_community_description: '自推出以來，Signal Sticker Maker已經幫助數千名用戶創建自訂貼圖包。我哋見到社區嘅驚人創意 - 從個人家庭貼圖到商業宣傳材料、教育資源同藝術表達。每個創建嘅貼圖包都代表住某人喺數碼通訊中嘅獨特聲音。',
  about_us_ads_description: '營運免費服務需要可持續嘅資金。我哋使用道德廣告做法，只同相關、高質素嘅廣告商合作。廣告收入幫助我哋維護伺服器、開發新功能，並保持服務對所有人免費。我哋承諾永遠唔會為咗廣告收入而犧牲用戶體驗或私隱。',
  about_us_future_title: '未來計劃',
  about_us_future_description: '我哋不斷努力改善Signal Sticker Maker。以下係我哋嘅計劃：',
  about_us_future_point_1: '用於微調貼圖嘅進階編輯工具',
  about_us_future_point_2: '批量處理以高效創建多個包',
  about_us_future_point_3: '快速貼圖創建嘅模板庫',
  about_us_future_point_4: '與其他訊息平台嘅整合',
  about_us_contact_title: '聯絡我哋',
  about_us_contact_description: '我哋喜歡聽到用戶嘅聲音！無論你有反饋、建議，或者只係想分享你嘅精彩貼圖創作，都唔好猶豫聯絡我哋。你嘅意見幫助我哋為所有人建立更好嘅工具。',
  faq_intro: '歡迎來到我哋嘅全面FAQ部分！喺呢度你會揾到關於製作自訂Signal貼圖、使用我哋嘅signal貼圖製作器、圖片格式、設計最佳實踐同故障排除等最常見問題嘅答案。無論你係新手定係想完善你嘅訊息應用貼圖製作技能，呢個指南都能幫到你。',
  faq_question_4: '支援咕圖片格式？',
  faq_answer_4: '我哋支援PNG、JPEG、WEBP同GIF格式。PNG適合有透明背景嘅圖片，JPEG適合相片，WEBP適合優化檔案大小，GIF適合簡單動畫。每種格式都有佢嘅優勢，視你嘅使用情況而定。',
  faq_question_5: '貼圖嘅建議圖片尺寸係咕？',
  faq_answer_5: '為咗最佳效果，使用至少512x512像素嘅圖片。呢樣可以確保你嘅貼圖喺所有設備上都清晰。建議最大尺寸係1024x1024像素，平衡品質同檔案大小。',
  faq_question_6: '一個貼圖包可以包含幾多個貼圖？',
  faq_answer_6: '你可以製作含有3到150個貼圖嘅貼圖包。我哋建議從10-30個貼圖開始，呢樣既有好嘅多樣性又保持管理方便。受歡迎嘅貼圖包通常有15-25個貼圖，涵蓋唔同情緒同情況。',
  faq_question_7: '我嘅圖片會儲存喺你哋嘅伺服器上嗎？',
  faq_answer_7: '唔會，我哋優先考慮你嘅私隱。圖片會被暫時處理，喺你嘅貼圖包製作完成後自動刪除。我哋唔會儲存你嘅任何個人圖片或資料。',
  faq_question_8: '我可以製作動畫貼圖嗎？',
  faq_answer_8: '可以！你可以上載GIF檔案來製作動畫貼圖。記住動畫貼圖應該簡單，唔好太長，以確保喺唔同設備上都有好嘅性能。',
  faq_still_questions_title: '仍然有問題？',
  faq_still_questions_description: '如果你揾唔到想要嘅答案，唔好猶豫聯絡我哋嘅支援團隊。我哋喺度幫你製作精彩嘅貼圖包！',
  faq_guides_description: '你也可以查看我哋關於貼圖製作同圖片格式選擇嘅詳細指南，獲得更深入嘅資訊。',
  faq_question_9: '點樣同其他人分享我嘅貼圖包？',
  faq_answer_9: '製作完成後，你會收到一個Signal貼圖包連結。你可以直接同朋友分享呢個連結、喺社交媒體上發佈，或者通過任何訊息應用發送。任何有連結嘅人都可以將你嘅貼圖加入佢嘅Signal應用。',
  faq_question_10: '如果我嘅貼圖喺Signal入面看起來唔岩？',
  faq_answer_10: '如果你嘅貼圖顯得模糊或歪曲，試下使用更高解像度嘅圖片（至少512x512像素）並確保佢哋係支援嘅格式。為咗最佳效果，有透明度嘅圖形使用PNG格式，相片類圖片使用JPEG。',
  faq_question_11: '我可以使用有版權嘅圖片嗎？',
  faq_answer_11: '你只應該使用你擁有或有權使用嘅圖片。包括你拍攝嘅相片、你創作嘅圖形，或者有適當授權嘅圖片。未經許可使用有版權嘅材料可能違反版權法。',
  faq_question_12: '我可以製作幾多個貼圖包有限制嗎？',
  faq_answer_12: '你可以製作嘅貼圖包數量沒有限制。盡情製作你想要嘅數量！每個包都係獨立嘅，可以有佢自己嘅主題、風格或用途。',
  faq_question_13: '製作完成後我可以編輯我嘅貼圖包嗎？',
  faq_answer_13: '一旦貼圖包製作完成並上載到Signal，就無法修改。不過，你可以製作一個新版本嘅貼圖包並分享新連結。呢個係Signal處理貼圖包嘅限制。',
  faq_question_14: '點解我應該選擇PNG而唔係JPEG？',
  faq_answer_14: 'PNG對於貼圖來說係理想嘅，因為佢支援透明度，讓你嘅貼圖可以同任何聊天背景完美融合。PNG也提供無損壓縮，確保你嘅圖形保持清晰。只有喺不需要透明度嘅相片類貼圖才使用JPEG。',
  faq_question_15: '咕樣才算好嘅貼圖設計？',
  faq_answer_15: '好嘅貼圖應該簡單、有表情、縮小時也容易識別。使用鮮明嘅顏色、清晰嘅線條，避免太多細節。考慮你想表達嘅情緒或反應，相應地設計。整個貼圖包保持風格一致會創造出統一嘅外觀。',
  faq_question_16: '我可以為商業用途製作貼圖嗎？',
  faq_answer_16: '當然可以！很多企業使用自訂貼圖來做市場推廣、客戶參與同品牌建設。你可以用你嘅標誌、吉祥物或品牌角色來製作貼圖。只要確保你有權使用任何品牌元素。',
  faq_question_17: '我需要特殊軟件來準備我嘅圖片嗎？',
  faq_answer_17: '不需要特殊軟件！你可以使用任何圖片編輯工具，從Photoshop等專業軟件到GIMP等免費替代品，甚至簡單嘅手機應用。關鍵係確保你嘅圖片符合尺寸同格式要求。',
  faq_question_18: 'WEBP同其他格式有咕區別？',
  faq_answer_18: 'WEBP係Google開發嘅現代格式，喺保持品質嘅同時提供出色嘅壓縮。佢通常比PNG細25-35%，同時支援透明度同動畫。不過，舊設備對WEBP嘅支援可能有限，所以PNG仍然係安全嘅通用選擇。',
};

const error = {
  error_file_size_title: '圖片超出最大檔案大小',
  error_file_size: '圖片檔案大小超過10 MB。請在上載前進一步降低圖片檔案大小。',
  error_conversion: '圖片轉換失敗。請嘗試使用其他瀏覽器或電腦。'
};

const translation = {
  ...language_spec,
  ...content,
  ...text,
  // Sticker Guide Section - Cantonese (for direct key access)
  sticker_guide_image_quality_title: text.sticker_guide_image_quality_title,
  sticker_guide_image_quality_1: text.sticker_guide_image_quality_1,
  sticker_guide_image_quality_2: text.sticker_guide_image_quality_2,
  sticker_guide_image_quality_3: text.sticker_guide_image_quality_3,
  sticker_guide_design_principles_title: text.sticker_guide_design_principles_title,
  sticker_guide_design_principles_1: text.sticker_guide_design_principles_1,
  sticker_guide_design_principles_2: text.sticker_guide_design_principles_2,
  sticker_guide_design_principles_3: text.sticker_guide_design_principles_3,
  sticker_guide_formats_title: text.sticker_guide_formats_title,
  sticker_guide_formats_description: text.sticker_guide_formats_description,
  sticker_guide_png_title: text.sticker_guide_png_title,
  sticker_guide_png_best_for: text.sticker_guide_png_best_for,
  sticker_guide_png_advantages: text.sticker_guide_png_advantages,
  sticker_guide_png_file_size: text.sticker_guide_png_file_size,
  sticker_guide_webp_title: text.sticker_guide_webp_title,
  sticker_guide_webp_best_for: text.sticker_guide_webp_best_for,
  sticker_guide_webp_advantages: text.sticker_guide_webp_advantages,
  sticker_guide_webp_file_size: text.sticker_guide_webp_file_size,
  sticker_guide_jpeg_title: text.sticker_guide_jpeg_title,
  sticker_guide_jpeg_best_for: text.sticker_guide_jpeg_best_for,
  sticker_guide_jpeg_advantages: text.sticker_guide_jpeg_advantages,
  sticker_guide_jpeg_limitations: text.sticker_guide_jpeg_limitations,
  sticker_guide_gif_title: text.sticker_guide_gif_title,
  sticker_guide_gif_best_for: text.sticker_guide_gif_best_for,
  sticker_guide_gif_advantages: text.sticker_guide_gif_advantages,
  sticker_guide_gif_limitations: text.sticker_guide_gif_limitations,
  sticker_guide_how_to_title: text.sticker_guide_how_to_title,
  sticker_guide_how_to_description: text.sticker_guide_how_to_description,
  sticker_guide_step_1: text.sticker_guide_step_1,
  sticker_guide_step_2: text.sticker_guide_step_2,
  sticker_guide_step_3: text.sticker_guide_step_3,
  sticker_guide_step_4: text.sticker_guide_step_4,
  sticker_guide_step_5: text.sticker_guide_step_5,
  sticker_guide_step_6: text.sticker_guide_step_6,
  sticker_guide_advanced_tips_title: text.sticker_guide_advanced_tips_title,
  sticker_guide_advanced_tips_description: text.sticker_guide_advanced_tips_description,
  sticker_guide_consistency_title: text.sticker_guide_consistency_title,
  sticker_guide_consistency_description: text.sticker_guide_consistency_description,
  sticker_guide_emotional_range_title: text.sticker_guide_emotional_range_title,
  sticker_guide_emotional_range_description: text.sticker_guide_emotional_range_description,
  sticker_guide_test_others_title: text.sticker_guide_test_others_title,
  sticker_guide_test_others_description: text.sticker_guide_test_others_description,
  ...menu_items,
  ...seo,
  ...error,
};

export default translation;
